/**
 * Is the app in this tab older than the one deployed?
 *
 * Every build stamps itself with a build id (vite.config.js: the Railway commit
 * sha, else the build time) and writes the same id to /version.json. A tab
 * keeps running the bundle it loaded, so after a deploy it shows none of the new
 * pages until it reloads. NewVersionNotice polls version.json and reloads the
 * tab when the two differ.
 */

/** The build this tab is running; null in dev and tests, where nothing is checked. */
// eslint-disable-next-line no-undef
export const CURRENT_BUILD = typeof __BUILD_ID__ !== 'undefined' && import.meta.env.PROD ? __BUILD_ID__ : null

/** The deployed build id, or null when it cannot be read (offline, mid-deploy). */
export async function fetchDeployedBuild(fetchImpl = fetch) {
  try {
    // no-store, and a query string for any proxy that ignores it.
    const res = await fetchImpl(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return null
    const body = await res.json()
    return typeof body?.build === 'string' ? body.build : null
  } catch {
    return null
  }
}

/** Only a build we could read, and that differs from ours, counts as newer. */
export const isOutdated = (current, deployed) => Boolean(current && deployed && current !== deployed)
